import { TextAreaAutoSize } from "@/Common/Components/Inputs/TextAreaAutoSize";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";

import styles from "./Notes.module.scss";

interface NotesProps {
    id: string;
    dataCy?: string;
    label?: string;
    value?: string;
    isEditable: boolean;
    containerClass?: string;
    onTextChange: (value: string) => void;
}

function Notes({ id, dataCy, isEditable, label, value = "", onTextChange, containerClass = "" }: Readonly<NotesProps>): JSX.Element {
    const { getText } = useTranslation();
    const flowsheetNotesId = `flowsheetNotes-${id}`;

    return (
        <div className={`${styles.notesContainer} ${containerClass}`}>
            <label
                htmlFor={flowsheetNotesId}
                className={styles.notesLabel}
            >
                {label ?? getText("NotesLabel")}
            </label>
            {isEditable
                ? (
                    <TextAreaAutoSize
                        dataCy={dataCy}
                        id={flowsheetNotesId}
                        value={value}
                        onTextChangeCallback={onTextChange}
                        minHeight="80px"
                        maxHeight="200px"
                        cssClass={styles.notesTextArea}
                        disabled={!isEditable}
                        maxLength={500}
                    />
                )
                : <p>{value}</p>
            }
        </div>
    );
}

export default Notes;
